module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issue_apply p_background user-select user-select clearfix",
    attrs: {
      "id": "apply_edit"
    }
  }, [_c('h3', {
    staticClass: "all_title",
    attrs: {
      "id": "issue_title"
    }
  }, [_vm._v("更新应用")]), _vm._v(" "), _c('div', {
    staticClass: "container_box",
    attrs: {
      "id": "container_box"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 partition_message"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "install_box"
  }, [_c('label', {
    staticClass: "file_text form_label"
  }, [_vm._v("\n\t    \t\t\t\t\t应用镜像包：\n\t    \t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "file_wrap inline-block pos-relative"
  }, [_c('form', [_c('div', {
    staticClass: "file_box"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "batchFile"
    },
    on: {
      "change": function($event) {
        return _vm.uploadWeb($event)
      }
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "glyphicon ico_del",
    on: {
      "click": function($event) {
        return _vm.delPackage($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "file_name text-space",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.webfileorignalname
    }
  }, [_vm._v(_vm._s(_vm.webfileorignalname))])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 partition_message"
  }, [_c('section', {
    staticClass: "issue_time_box partition_message"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "issue_time_container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row publick_form_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label content_block",
    attrs: {
      "for": ""
    }
  }, [_vm._v("发布时间：")]), _vm._v(" "), _c('div', {
    staticClass: "issue_time_radio_box content_block pd_l27"
  }, [_c('div', {
    staticClass: "issue_time_radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.publishType),
      expression: "tCloudAppVersion.publishType"
    }],
    staticClass: "radio_input_y",
    attrs: {
      "type": "radio",
      "name": "radio_issue_time",
      "id": "issue_time_radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tCloudAppVersion.publishType, "1")
    },
    on: {
      "click": function($event) {
        return _vm.openSub(1)
      },
      "change": function($event) {
        return _vm.$set(_vm.tCloudAppVersion, "publishType", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form_label radio_label",
    attrs: {
      "for": "issue_time_radio"
    }
  }, [_vm._v("审核后立即发布")])]), _vm._v(" "), _c('div', {
    staticClass: "issue_time_radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.publishType),
      expression: "tCloudAppVersion.publishType"
    }],
    staticClass: "radio_input_y",
    attrs: {
      "type": "radio",
      "name": "radio_issue_time",
      "id": "issue_time_radio1",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tCloudAppVersion.publishType, "2")
    },
    on: {
      "click": function($event) {
        return _vm.openSub(2)
      },
      "change": function($event) {
        return _vm.$set(_vm.tCloudAppVersion, "publishType", "2")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form_label radio_label",
    attrs: {
      "for": "issue_time_radio1"
    }
  }, [_vm._v("定时发布")]), _vm._v(" "), _c('div', {
    staticClass: "time_option",
    staticStyle: {
      "display": "none"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.tCloudAppVersion.publishTime),
      callback: function($$v) {
        _vm.$set(_vm.tCloudAppVersion, "publishTime", $$v)
      },
      expression: "tCloudAppVersion.publishTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "issue_time_radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.publishType),
      expression: "tCloudAppVersion.publishType"
    }],
    staticClass: "radio_input_y",
    attrs: {
      "type": "radio",
      "name": "radio_issue_time",
      "id": "issue_time_radio2",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.tCloudAppVersion.publishType, "3")
    },
    on: {
      "click": function($event) {
        return _vm.openSub(3)
      },
      "change": function($event) {
        return _vm.$set(_vm.tCloudAppVersion, "publishType", "3")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form_label radio_label",
    attrs: {
      "for": "issue_time_radio2"
    }
  }, [_vm._v("审核后手动确认")])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 partition_message"
  }, [_vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "explain_box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.versionComment),
      expression: "tCloudAppVersion.versionComment"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "rows": "10",
      "placeholder": "简介(字数不少于20字且最多500字)"
    },
    domProps: {
      "value": (_vm.tCloudAppVersion.versionComment)
    },
    on: {
      "change": function($event) {
        return _vm.valdata1()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudAppVersion, "versionComment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 partition_message"
  }, [_c('h4', {
    staticClass: "message_title"
  }, [_vm._v("版本")]), _vm._v(" "), _vm._l((_vm.versionList), function(list) {
    return _c('section', {
      staticClass: "install_box"
    }, [_c('p', [_vm._v(_vm._s(list.versionNo))])])
  })], 2), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('section', {
    staticClass: "basic_message partition_message"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "basic_container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row publick_form_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudApp.appName),
      expression: "tCloudApp.appName"
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "issue_applyName",
      "disabled": "disabled",
      "placeholder": "应用名称最多输入20个汉字"
    },
    domProps: {
      "value": (_vm.tCloudApp.appName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudApp, "appName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tip_sub_text text_margin_left"
  }, [_vm._v("(上线不能修改应用名称)")])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudApp.appEnName),
      expression: "tCloudApp.appEnName"
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "issue_applyEnName",
      "disabled": "disabled",
      "placeholder": "应用名称最多输入20个英文字母"
    },
    domProps: {
      "value": (_vm.tCloudApp.appEnName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudApp, "appEnName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.versionNo),
      expression: "tCloudAppVersion.versionNo"
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "issue_applyNumber",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.tCloudAppVersion.versionNo)
    },
    on: {
      "change": function($event) {
        return _vm.valdataVersionNo()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudAppVersion, "versionNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tip_sub_text text_margin_left"
  }, [_vm._v("(与安装包版本一致)")])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(9), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudApp.businessType),
      expression: "tCloudApp.businessType"
    }],
    staticClass: "form-control form_control",
    attrs: {
      "id": "issue_select",
      "disabled": "disabled"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tCloudApp, "businessType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择分类")]), _vm._v(" "), _vm._l((_vm.appTypeOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(option.dictionaryname) + "\n\t\t\t\t\t\t\t\t\t")])
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "form_box line_block",
    attrs: {
      "id": "issue_checkbox"
    }
  }, [_vm._m(10), _vm._v(" "), _vm._l((_vm.appRange), function(range, index) {
    return _c('div', {
      staticClass: "radio_box"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.rangeCheck),
        expression: "rangeCheck"
      }],
      staticClass: "radio_input_f",
      attrs: {
        "type": "checkbox",
        "id": 'rangid' + index,
        "disabled": "disabled",
        "name": "group_radio"
      },
      domProps: {
        "value": range.id,
        "checked": Array.isArray(_vm.rangeCheck) ? _vm._i(_vm.rangeCheck, range.id) > -1 : (_vm.rangeCheck)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.rangeCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = range.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.rangeCheck = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.rangeCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.rangeCheck = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form_label radio_label",
      attrs: {
        "for": 'rangid' + index
      }
    }, [_vm._v(_vm._s(range.dictionaryname))])])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "form_box line_block",
    attrs: {
      "id": "issue_checkbox1"
    }
  }, [_vm._m(11), _vm._v(" "), _vm._l((_vm.appAddServices), function(addservices, index) {
    return _c('div', {
      staticClass: "radio_box"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.addservicesCheck),
        expression: "addservicesCheck"
      }],
      staticClass: "radio_input_f",
      attrs: {
        "type": "checkbox",
        "id": 'addservicesid' + index,
        "disabled": "disabled",
        "name": "group_radio"
      },
      domProps: {
        "value": addservices.id,
        "checked": Array.isArray(_vm.addservicesCheck) ? _vm._i(_vm.addservicesCheck, addservices.id) > -1 : (_vm.addservicesCheck)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.addservicesCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = addservices.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.addservicesCheck = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.addservicesCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.addservicesCheck = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form_label radio_label",
      attrs: {
        "for": 'addservicesid' + index
      }
    }, [_vm._v(_vm._s(addservices.dictionaryname))])])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "form_box line_block",
    attrs: {
      "id": "issue_checkbox2"
    }
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.appInterface), function(interface, index) {
    return _c('div', {
      staticClass: "radio_box"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.interfaceCheck),
        expression: "interfaceCheck"
      }],
      staticClass: "radio_input_f",
      attrs: {
        "type": "checkbox",
        "id": 'interfaceid' + index,
        "disabled": "disabled",
        "name": "group_radio"
      },
      domProps: {
        "value": interface.id,
        "checked": Array.isArray(_vm.interfaceCheck) ? _vm._i(_vm.interfaceCheck, interface.id) > -1 : (_vm.interfaceCheck)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.interfaceCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = interface.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.interfaceCheck = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.interfaceCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.interfaceCheck = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form_label radio_label",
      attrs: {
        "for": 'interfaceid' + index
      }
    }, [_vm._v(_vm._s(interface.dictionaryname))])])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "form_box line_block",
    attrs: {
      "id": "deploy_type"
    }
  }, [_vm._m(13), _vm._v(" "), _vm._l((_vm.deployType), function(deploytypech, index) {
    return _c('div', {
      staticClass: "radio_box"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tCloudApp.deployType),
        expression: "tCloudApp.deployType"
      }],
      staticClass: "radio_input_y",
      attrs: {
        "type": "radio",
        "id": 'deploytypeid' + index,
        "disabled": "disabled",
        "name": "group_radio"
      },
      domProps: {
        "value": deploytypech.id,
        "checked": _vm._q(_vm.tCloudApp.deployType, deploytypech.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.tCloudApp, "deployType", deploytypech.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form_label radio_label",
      attrs: {
        "for": 'deploytypeid' + index
      }
    }, [_vm._v(_vm._s(deploytypech.dictionaryname))])])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "form_box line_block",
    attrs: {
      "id": "client_type"
    }
  }, [_vm._m(14), _vm._v(" "), _vm._l((_vm.clientType), function(clienttypech, index) {
    return _c('div', {
      staticClass: "radio_box"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.clientTypeArray),
        expression: "clientTypeArray"
      }],
      staticClass: "radio_input_f",
      attrs: {
        "type": "checkbox",
        "id": 'clienttypech' + index,
        "name": "group_radio_range"
      },
      domProps: {
        "value": clienttypech.id,
        "checked": Array.isArray(_vm.clientTypeArray) ? _vm._i(_vm.clientTypeArray, clienttypech.id) > -1 : (_vm.clientTypeArray)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.clientTypeArray,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = clienttypech.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.clientTypeArray = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.clientTypeArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.clientTypeArray = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form_label radio_label",
      attrs: {
        "for": 'clienttypech' + index
      }
    }, [_vm._v(_vm._s(clienttypech.dictionaryname))])])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "form_box line_block",
    attrs: {
      "id": "window_type"
    }
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "radio_box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.openType),
      expression: "tCloudAppVersion.openType"
    }],
    staticClass: "radio_input_y",
    attrs: {
      "name": "open_window",
      "type": "radio",
      "id": "newwindow",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tCloudAppVersion.openType, "1")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tCloudAppVersion, "openType", "1")
      }, function($event) {
        return _vm.newwindow()
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio_label form_label",
    attrs: {
      "for": "newwindow"
    }
  }, [_vm._v("新窗口")])]), _vm._v(" "), _c('div', {
    staticClass: "radio_box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.openType),
      expression: "tCloudAppVersion.openType"
    }],
    staticClass: "radio_input_y",
    attrs: {
      "name": "open_window",
      "type": "radio",
      "id": "newinternal",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tCloudAppVersion.openType, "2")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tCloudAppVersion, "openType", "2")
      }, function($event) {
        return _vm.newwindow1()
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio_label form_label",
    attrs: {
      "for": "newinternal"
    }
  }, [_vm._v("内置窗口")])]), _vm._v(" "), (_vm.tCloudAppVersion.openType == '2') ? _c('div', {
    staticClass: "window_size inline-block-3"
  }, [_c('section', [_c('span', [_vm._v("宽")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.windowWidth),
      expression: "tCloudAppVersion.windowWidth"
    }],
    staticClass: "form-control small_input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tCloudAppVersion.windowWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudAppVersion, "windowWidth", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("px;")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("高")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.windowHeight),
      expression: "tCloudAppVersion.windowHeight"
    }],
    staticClass: "form-control small_input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tCloudAppVersion.windowHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudAppVersion, "windowHeight", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("px")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(16), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppVersion.appComment),
      expression: "tCloudAppVersion.appComment"
    }],
    staticClass: "form-control form_textarea",
    attrs: {
      "name": "",
      "id": "issue_textarea",
      "rows": "5",
      "placeholder": "简介(字数不少于60字且最多五百字)"
    },
    domProps: {
      "value": (_vm.tCloudAppVersion.appComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudAppVersion, "appComment", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('section', {
    staticClass: "material_icon_box partition_message"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "material_icon_container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row publick_form_box"
  }, [_c('section', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "file_text"
  }, [_vm._v("\n\t\t    \t\t\t\t\t应用图标：\n\t\t    \t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "file_box",
    style: ({
      backgroundImage: 'url(' + _vm.fileImg + ')'
    })
  }, [_c('form', {
    attrs: {
      "id": "subform",
      "enctype": "multipart/form-data",
      "method": "post",
      "action": "/zklccloud/uploadImages"
    }
  }, [_c('input', {
    class: {
      'vis-hide': _vm.classVisFlag
    },
    attrs: {
      "type": "file",
      "name": "file"
    },
    on: {
      "click": function($event) {
        return _vm.disabledF($event)
      },
      "change": function($event) {
        return _vm.uploadImage($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "type",
      "value": "2"
    }
  })])]), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _c('section', {
    staticClass: "col-sm-3"
  }, [_c('h5', [_vm._v("更多尺寸：")]), _vm._v(" "), _c('div', {
    staticClass: "row more_content text-center"
  }, _vm._l((_vm.icolist), function(icon) {
    return _c('a', {
      staticClass: "col-sm-6",
      attrs: {
        "href": icon.filePath,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(icon.viewSize) + "*" + _vm._s(icon.viewSize))])
  }), 0)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "screenshot_box partition_message"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "screenshot_container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row publick_form_box"
  }, [_vm._m(20), _vm._v(" "), _vm._l((_vm.paths), function(path, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (path.length != 0),
        expression: "path.length!=0"
      }],
      staticClass: "img_box pos-relative"
    }, [_c('img', {
      attrs: {
        "src": path
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "glyphicon ico_del",
      on: {
        "click": function($event) {
          return _vm.delImg(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paths.length <= 5),
      expression: "paths.length<=5"
    }],
    staticClass: "file_box"
  }, [_c('form', [_c('input', {
    attrs: {
      "type": "file",
      "name": "file",
      "id": "addAppImage"
    },
    on: {
      "change": function($event) {
        return _vm.addAppImage()
      }
    }
  })])])], 2)])])]), _vm._v(" "), _c('section', {
    staticClass: "authorization_box partition_message"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "authorization_container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row publick_form_box"
  }, [_c('section', {
    staticClass: "form_box line_block"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("授权类型：")]), _vm._v(" "), _c('div', {
    staticClass: "radio_box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudApp.authType),
      expression: "tCloudApp.authType"
    }],
    staticClass: "radio_input_y",
    attrs: {
      "type": "radio",
      "id": "radio_authorization2",
      "name": "radio_authorization",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tCloudApp.authType, "1")
    },
    on: {
      "click": function($event) {
        return _vm.authorizationBoxShow($event)
      },
      "change": function($event) {
        return _vm.$set(_vm.tCloudApp, "authType", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form_label radio_label",
    attrs: {
      "for": "radio_authorization2"
    }
  }, [_vm._v("公开发布")])]), _vm._v(" "), _c('div', {
    staticClass: "radio_box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudApp.authType),
      expression: "tCloudApp.authType"
    }],
    staticClass: "radio_input_y ",
    attrs: {
      "type": "radio",
      "id": "radio_authorization1",
      "name": "radio_authorization",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tCloudApp.authType, "2")
    },
    on: {
      "click": function($event) {
        return _vm.authorizationBoxShow($event)
      },
      "change": function($event) {
        return _vm.$set(_vm.tCloudApp, "authType", "2")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form_label radio_label",
    attrs: {
      "for": "radio_authorization1"
    }
  }, [_vm._v("隐私发布")])])]), _vm._v(" "), _c('section', {
    staticClass: "form_box text-center",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "radio_authorization_form_box"
    }
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("授权码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudApp.authCode),
      expression: "tCloudApp.authCode"
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "name": "",
      "id": "",
      "value": "",
      "placeholder": "请输入授权码"
    },
    domProps: {
      "value": (_vm.tCloudApp.authCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudApp, "authCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_reload",
    on: {
      "click": function($event) {
        return _vm.authorizationBoxShow()
      }
    }
  }), _vm._v(" "), _vm._m(22)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn_box text-center partition_message"
  }, [_c('span', {
    staticClass: "btn btn_submit",
    attrs: {
      "id": "save_app_btn"
    },
    on: {
      "click": function($event) {
        return _vm.doSubmit($event)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (!_vm.hidsub) ? _c('span', {
    staticClass: "btn btn_submit",
    attrs: {
      "id": "inspect_app_btn"
    },
    on: {
      "click": function($event) {
        return _vm.doSubmit($event)
      }
    }
  }, [_vm._v("提交审核")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("应用镜像包")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress progress-striped active",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-info",
    staticStyle: {
      "width": "0%"
    },
    attrs: {
      "id": "progressBar",
      "role": "progressbar",
      "aria-valuemin": "0",
      "aria-valuenow": "0",
      "aria-valuemax": "100"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("发布时间")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("版本更新说明")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress progress-striped active",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-info",
    staticStyle: {
      "width": "0%"
    },
    attrs: {
      "id": "progressBar",
      "role": "progressbar",
      "aria-valuemin": "0",
      "aria-valuenow": "0",
      "aria-valuemax": "100"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("基本信息")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("应用名称：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("应用英文名称：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("版本编号：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("应用分类：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("群体范围：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("增值服务：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("数据接口权限：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("部署类型：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("支持客户端：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('span', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t窗口打开方式：\n\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("应用介绍：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("图标素材")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip_text"
  }, [_c('p', [_vm._v("要求：")]), _vm._v(" "), _c('p', [_vm._v("1.等边矩形")]), _vm._v(" "), _c('p', [_vm._v("2.PNG、JPG")]), _vm._v(" "), _c('p', [_vm._v("3.尺寸≥512px")]), _vm._v(" "), _c('p', [_vm._v("4.不超过1M")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("应用截图")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', {
    staticClass: "tip_small_text"
  }, [_vm._v("请上传2-5张图片,大于500px,格式PNG\\JPG,2M以内大小")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("授权类型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip_sub_text hint_small_left"
  }, [_c('small', [_vm._v("(不在应用库中显示,通过搜索授权码显示)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-31721996"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/edit_app.vue
// module id = 1246
// module chunks = 1